/**
 * Veluna guide popup - email first; the code, the topic link and the guide
 * follow on the success screen.
 * Rebuilt 2026-09-22 in the guides' design language. REDESIGNED 2026-10-01
 * (owner-approved mock): bone card with a linen media panel showing the guide
 * cover on desktop, a bottom sheet with a cover thumbnail on phones. The
 * Mind/Body/Skin picker is no longer the first step: the popup opens straight
 * on the email step on every surface. Concern: articles keep articleConcern()
 * (VELUNA_BLOG_CLUSTER); home, browse and unmapped articles default to Mind
 * Calm (mc). Triggers, suppression, measurement (gtag veluna_popup_shown /
 * veluna_popup_dismissed), the topic map and the POST body are unchanged.
 * Replaces the first block of veluna-pdf-capture.js.
 *
 * SURFACES
 *   homepage       scroll past half, exit intent (desktop), or 45s on the page
 *   blog articles  gentle only (2026-09-23): desktop 60% read or exit intent;
 *                  touch 60% read AND 30s on the page. The article's mapped
 *                  concern (VELUNA_BLOG_CLUSTER) is pre-selected. source
 *                  article_capture. Replaces veluna-homepage-popup.js there.
 *   cart           NONE since 2026-09-23 (it competed with checkout).
 *
 * DISMISSAL (2026-09-23): X, Esc, backdrop or "No thanks" suppresses the popup
 * for 7 days and for the rest of the session. It used to write only a 60s
 * cooldown and re-arm a timer, so it came back every minute. After a capture
 * nothing asks again. generate_lead fires on a 2xx only.
 *
 * ROUTING. Every submission carries a concern code (mc / dr / ss) at the top
 * level. The email engine's welcome sequence fills {concern_name}, {guide_url}
 * and {product_url} from that code, so the first email is that ritual's guide.
 * Circadian Reset (cr) is no longer offered: the tuning was hidden 2026-09-22.
 *
 * WHAT WAS REMOVED: the fourth option (Circadian Reset), "14-page" (Deep
 * Restore's guide is 13), and "personalized".
 *
 * Captured state is written to every key the site's other captures read
 * (veluna_email_captured, veluna_pdf_captured, veluna_quiz_email), so a person
 * who signs up here is never asked again anywhere else.
 */
(function () {
  'use strict';

  var CONFIG = {
    backend: {
      url: 'https://ary09mimgg.execute-api.us-east-2.amazonaws.com/Prod/subscribe',
      sequence: 'welcome',
      popupVariant: 'guide_v2'
    },
    timing: { dwellMs: 20000, cooldownMs: 60000, scrollThreshold: 0.3,
              articleScroll: 0.4, articleMobileMinMs: 15000, suppressMs: 7 * 24 * 60 * 60 * 1000 },
    storage: {
      captured: 'veluna_email_captured',
      dismissed: 'veluna_popup_dismissed_forever',
      lastShown: 'veluna_popup_last_shown',
      cartShown: 'veluna_cart_popup_shown',
      dismissedUntil: 'veluna_popup_dismissed_until',
      sessionDismissed: 'veluna_popup_dismissed_session'
    },
    concerns: [
      { id: 'mc', name: 'Mind', ritual: 'Mind Calm', line: 'A head that will not stop at lights out.',
        sub: 'Quiet the Mental Chatter', product: '/products/mind-calm-ritual-set', match: 'mind-calm',
        guide: 'https://cdn.shopify.com/s/files/1/0660/1372/4750/files/Veluna-Mind-Calm-Sleep-Guide_498c431a-e208-4dc2-a82f-ecfe391e66ee.pdf?v=1790031056' },
      { id: 'dr', name: 'Body', ritual: 'Deep Restore', line: 'A body still holding the day.',
        sub: 'Release Physical Tension', product: '/products/deep-restore-ritual-set', match: 'deep-restore',
        guide: 'https://cdn.shopify.com/s/files/1/0660/1372/4750/files/Veluna-Deep-Restore-Sleep-Guide_4b0e977e-e588-46b3-a770-60a1a3dea23d.pdf?v=1790031062' },
      { id: 'ss', name: 'Skin', ritual: 'Sacred Soothe', line: 'Short nights that show on your face.',
        sub: 'Nurture Your Spirit', product: '/products/sacred-soothe-ritual-set-1', match: 'sacred-soothe',
        guide: 'https://cdn.shopify.com/s/files/1/0660/1372/4750/files/Veluna-Sacred-Soothe-Sleep-Guide_6e6345f9-2f2e-434f-b89d-4fe916f28d47.pdf?v=1790031067' }
    ]
  };

  var popupEl = null, selected = null, isOpen = false, dwellTimer = null, triggersInstalled = false, releaseFocus = null;

  function ls(k) { try { return localStorage.getItem(k); } catch (_) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (_) {} }
  function ssGet(k) { try { return sessionStorage.getItem(k); } catch (_) { return null; } }
  function ssSet(k, v) { try { sessionStorage.setItem(k, v); } catch (_) {} }
  function isCaptured() {
    return ls(CONFIG.storage.captured) === 'true' || !!ls('veluna_pdf_captured') ||
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((ls('veluna_quiz_email') || '').trim());
  }
  function isPermanentlyDismissed() {
    if (ls(CONFIG.storage.dismissed) === 'true') return true;
    if (ssGet(CONFIG.storage.sessionDismissed)) return true;
    var until = parseInt(ls(CONFIG.storage.dismissedUntil) || '0', 10);
    return !!until && Date.now() < until;
  }
  function fireLead(p) {
    try { if (typeof window.gtag === 'function') window.gtag('event', 'generate_lead', p); } catch (_) {}
    try { (window.dataLayer = window.dataLayer || []).push({ event: 'generate_lead', source: p.source, concern: p.concern, surface: p.surface }); } catch (_) {}
  }
  function sourceName() { return surface() === 'article' ? 'article_capture' : 'veluna_quiz_popup'; }
  /* 2026-10-01: popup measurement shared with every capture engine. One GA4 event per
     open (engine, surface, trigger) and one per dismissal (engine, surface). The
     existing dataLayer pushes stay as they are. */
  function gaPopup(ev, p) { try { if (typeof window.gtag === 'function') window.gtag('event', ev, p); } catch (_) {} }
  function triggerName(r) {
    r = String(r || '');
    if (r === 'exit-intent' || r === 'scroll' || r === 'scroll-up' || r === 'idle') return r;
    if (r === 'dwell' || r === 'scroll-dwell') return 'dwell';
    return 'manual';
  }
  function articleConcern() {
    var id = String(window.VELUNA_BLOG_CLUSTER || '').toLowerCase();
    return CONFIG.concerns.filter(function (c) { return c.id === id; })[0] || null;
  }
  /* 2026-10-01: topic-matched copy on articles, keyed by words in the article handle
     (first match wins). Each line promises exactly what happens: the code and the page
     link appear on the success screen now, the guide arrives by email. No health claims.
     On the linked page itself the default copy shows instead. */
  var TOPICS = [
    { re: /magnesium/, h: 'Reading about magnesium doses?',
      sub: 'Get your 10% off code now, the dose table link, and the sleep guide by email.',
      link: '/blogs/journal/sleep-supplement-doses-used-in-trials', label: 'Open the dose table' },
    { re: /melatonin/, h: 'Choosing a melatonin dose?',
      sub: 'Get your 10% off code now, the dose chart link, and the sleep guide by email.',
      link: '/blogs/journal/low-dose-melatonin-how-to-choose-a-dose', label: 'Open the dose chart' },
    { re: /biotin|hair-skin|gummies/, h: 'Comparing hair, skin and nails gummies?',
      sub: 'Get your 10% off code now, the what-to-check list link, and the sleep guide by email.',
      link: '/blogs/journal/hair-skin-and-nails-gummies-what-to-check', label: 'Open the what-to-check list' },
    { re: /collagen/, h: 'Comparing collagen powders?',
      sub: 'Get your 10% off code now, the collagen powder guide link, and the sleep guide by email.',
      link: '/blogs/journal/how-to-choose-a-collagen-powder', label: 'Open the collagen powder guide' },
    { re: /ashwagandha/, h: 'Comparing ashwagandha supplements?',
      sub: 'Get your 10% off code now, the ashwagandha buying guide link, and the sleep guide by email.',
      link: '/blogs/journal/how-to-choose-an-ashwagandha-supplement', label: 'Open the ashwagandha buying guide' }
  ];
  function topic() {
    if (surface() !== 'article') return null;
    var path = window.location.pathname.replace(/\/+$/, '');
    var m = /^\/blogs\/[^/]+\/([^/?#]+)/.exec(path);
    var handle = m ? m[1].toLowerCase() : '';
    for (var i = 0; i < TOPICS.length; i++) {
      if (TOPICS[i].re.test(handle)) return path === TOPICS[i].link ? null : TOPICS[i];
    }
    return null;
  }
  function inCooldown() {
    var last = parseInt(ls(CONFIG.storage.lastShown) || '0', 10);
    return last && (Date.now() - last) < CONFIG.timing.cooldownMs;
  }
  function recordShown() { lsSet(CONFIG.storage.lastShown, String(Date.now())); }

  function surface() {
    var p = window.location.pathname;
    if (p.indexOf('/checkout') !== -1) return null;
    /* 2026-09-23: no capture on the cart at all; it competed with checkout. */
    if (p === '/cart' || p.indexOf('/cart/') === 0) return null;
    if (p === '/' || p === '/index' || p === '') return 'home';
    if (/^\/blogs\/[^/]+\/[^/]+/.test(p)) return 'article';
    /* 2026-09-29: browse pages get the guide on exit intent only (desktop).
       Pages with their own capture or a form are left out. */
    if (/^\/(pages\/(ritual-quiz|my-ritual|mind-calm|contact|partner)|account|search|password)/.test(p)) return null;
    if (/^\/(pages|collections)\//.test(p) || /^\/blogs\/[^/]+\/?$/.test(p)) return 'browse';
    return null;
  }

  /* ?popup_preview=1 bypasses "already signed up", cooldowns and the guard so
     the owner can see the popup on a browser that has signed up before. */
  var PREVIEW = /[?&]popup_preview=1\b/.test(window.location.search);

  /* An exit (pointer leaving the window) may open while the buy box is on
     screen; every other guard rule still applies. 2026-09-29. */
  var EXITING = false;
  function guardAllows(id) {
    var G = window.VelunaCaptureGuard;
    if (!G) return true;
    var r = G.reason ? G.reason(id) : (G.mayShow(id) ? null : 'blocked');
    return r === null || (EXITING && r === 'commerce_configuration_visible');
  }
  function shouldShow() {
    if (!surface()) return false;
    if (PREVIEW) return !isOpen;
    var claimed = (window.__vlnPageSpecific || []).filter(function (id) { return id && id !== 'pdf-capture'; });
    if (claimed.length) return false;
    if (window.VelunaCaptureGuard && window.VelunaCaptureGuard.hasPageSpecific('pdf-capture')) return false;
    if (!guardAllows('pdf-capture')) return false;
    if (isCaptured() || isPermanentlyDismissed() || isOpen || inCooldown()) return false;
    if (surface() === 'cart' && ssGet(CONFIG.storage.cartShown)) return false;
    return true;
  }

  /* 2026-10-01 redesign. The three families come from the theme's own variables
     (snippets/veluna-typography.liquid: --veluna-serif / --veluna-ui / --veluna-mono)
     with literal fallbacks; !important because several theme stylesheets load
     asynchronously and would otherwise win on declaration order. Hooks kept:
     .vqp__overlay(.is-open), .vqp__card, .vqp__close, .vqp__frame[data-body],
     .vqp__input, .vqp__btn[data-submit], data-topic-link, data-skip. */
  function injectStyles() {
    if (document.getElementById('vqp-styles')) return;
    var SERIF = 'var(--veluna-serif,Newsreader,Georgia,serif)!important';
    var UI = 'var(--veluna-ui,"Hanken Grotesk",system-ui,sans-serif)!important';
    var MONO = 'var(--veluna-mono,"DM Mono",ui-monospace,monospace)!important';
    var O = '.vqp__overlay ';
    var css = [
      '.vqp__overlay{position:fixed;inset:0;background:rgba(27,27,27,.45);-webkit-backdrop-filter:blur(2px);backdrop-filter:blur(2px);z-index:999999;display:flex;align-items:center;justify-content:center;padding:16px;box-sizing:border-box;opacity:0;transition:opacity .25s ease;}',
      '.vqp__overlay.is-open{opacity:1;}',
      '.vqp__overlay *,.vqp__overlay *::before,.vqp__overlay *::after{box-sizing:border-box;}',
      '.vqp__card{position:relative;display:grid;grid-template-columns:300px minmax(0,1fr);width:100%;max-width:760px;max-height:92vh;overflow:auto;background:#FBF9F5;color:#131313;border:1px solid #ECE7DF;border-radius:18px;box-shadow:0 30px 80px rgba(20,20,20,.35);text-align:left;font-family:' + UI + ';transform:translateY(10px);transition:transform .25s ease;}',
      '.vqp__overlay.is-open .vqp__card{transform:none;}',
      '.vqp__handle{display:none;width:40px;height:4px;border-radius:2px;background:#D5CFC4;margin:14px auto 0;}',
      '.vqp__media{display:flex;align-items:center;justify-content:center;padding:28px;background:#E9DDD1;}',
      '.vqp__media img{display:block;width:auto;height:auto;max-width:100%;max-height:360px;border-radius:8px;box-shadow:0 12px 30px rgba(0,0,0,.18);}',
      '.vqp__frame{min-width:0;padding:34px 36px 30px;text-align:left;}',
      O + '.vqp__close{position:absolute;top:14px;right:14px;width:36px;height:36px;display:flex;align-items:center;justify-content:center;padding:0;margin:0;background:transparent;border:0;border-radius:50%;cursor:pointer;color:#6A6D78;line-height:0;}',
      O + '.vqp__close:hover{color:#131313;background:rgba(19,19,19,.06);}',
      '.vqp__head{display:flex;align-items:center;gap:14px;}',
      '.vqp__head-text{min-width:0;flex:1 1 auto;}',
      '.vqp__thumb{display:none;flex:0 0 64px;width:64px;height:84px;object-fit:cover;border-radius:6px;box-shadow:0 6px 16px rgba(0,0,0,.18);}',
      O + '.vqp__brand{margin:0 0 14px;font-family:' + MONO + ';font-weight:500;font-size:11px;line-height:1;letter-spacing:.14em;text-transform:uppercase;color:#9A7B55;}',
      O + '.vqp__h{margin:0 0 12px;font-family:' + SERIF + ';font-weight:500!important;font-size:30px;line-height:1.15;letter-spacing:-.01em;color:#131313!important;text-wrap:balance;}',
      O + '.vqp__sub{margin:0 0 20px;max-width:none;font-family:' + UI + ';font-size:16px;line-height:1.5;color:#4a4d57;}',
      '.vqp__form{display:flex;flex-direction:column;gap:0;text-align:left;margin:0;}',
      '.vqp__row{display:flex;gap:10px;}',
      O + '.vqp__input{flex:1 1 auto;min-width:0;width:100%;height:50px;min-height:50px;margin:0;padding:0 16px;border:1px solid #D5CFC4;border-radius:12px;background:#fff;color:#1b1b1b;font-family:' + UI + ';font-size:16px;line-height:normal;box-shadow:none;-webkit-appearance:none;appearance:none;}',
      O + '.vqp__input::placeholder{color:#8A8D98;opacity:1;}',
      O + '.vqp__input:focus{outline:2px solid #C8A27B;outline-offset:1px;border-color:#C8A27B;}',
      O + '.vqp__btn{display:inline-flex;align-items:center;justify-content:center;flex:0 0 auto;height:50px;min-height:50px;margin:0;padding:0 22px;border:0;border-radius:12px;background:#C8A27B;color:#131313;font-family:' + UI + ';font-size:16px;font-weight:600;line-height:1;white-space:nowrap;cursor:pointer;text-decoration:none;-webkit-appearance:none;appearance:none;}',
      O + '.vqp__btn:hover{background:#BE966D;color:#131313;}',
      O + '.vqp__btn[disabled]{opacity:.6;cursor:wait;}',
      O + '.vqp__error{min-height:0;margin:0;font-family:' + UI + ';font-size:13px;line-height:1.4;color:#A5522B;}',
      O + '.vqp__error:not(:empty){margin-top:8px;}',
      O + '.vqp__legal{margin:12px 0 0;font-family:' + UI + ';font-size:12.5px;line-height:1.5;color:#6A6D78;text-align:left;}',
      O + '.vqp__trust{display:flex;flex-wrap:wrap;gap:16px;margin:18px 0 0;font-family:' + MONO + ';font-weight:500;font-size:11px;line-height:1;letter-spacing:.08em;text-transform:uppercase;color:#6A6D78;}',
      O + '.vqp__skip{display:inline-block;margin:14px 0 0;padding:0;background:transparent;border:0;cursor:pointer;font-family:' + UI + ';font-size:14px;line-height:1.4;color:#6A6D78;text-decoration:underline;text-underline-offset:3px;}',
      O + '.vqp__skip:hover{color:#131313;}',
      '.vqp__code{display:flex;align-items:center;flex-wrap:wrap;gap:10px;margin:6px 0 10px;}',
      O + '.vqp__code-value{display:inline-block;padding:10px 16px;background:#fff;border:1px dashed #C8A27B;border-radius:10px;font-family:' + MONO + ';font-weight:500;font-size:26px;line-height:1;letter-spacing:.06em;color:#131313;user-select:all;-webkit-user-select:all;}',
      O + '.vqp__copy{height:44px;margin:0;padding:0 16px;border:1px solid #D5CFC4;border-radius:10px;background:#fff;color:#131313;font-family:' + UI + ';font-size:14px;font-weight:600;line-height:1;cursor:pointer;-webkit-appearance:none;appearance:none;}',
      O + '.vqp__copy:hover{border-color:#C8A27B;}',
      O + '.vqp__copied{min-height:0;margin:0;font-family:' + UI + ';font-size:13px;line-height:1.4;color:#4a4d57;}',
      O + '.vqp__copied:not(:empty){margin:0 0 10px;}',
      '.vqp__links{display:flex;flex-wrap:wrap;gap:10px;margin:14px 0 0;}',
      O + '.vqp__link{display:inline-block;margin:0;padding:11px 16px;border:1px solid #D5CFC4;border-radius:12px;background:#fff;color:#131313;font-family:' + UI + ';font-size:15px;font-weight:600;line-height:1.2;text-decoration:none;}',
      O + '.vqp__link:hover{border-color:#C8A27B;color:#131313;}',
      O + '.vqp__link--topic{background:#C8A27B;border-color:#C8A27B;}',
      O + '.vqp__pick{display:flex;flex-wrap:wrap;align-items:center;gap:4px 14px;margin:14px 0 0;font-family:' + UI + ';font-size:13px;line-height:1.4;color:#6A6D78;}',
      O + '.vqp__pick a{color:#131313;font-weight:600;text-decoration:underline;text-underline-offset:3px;}',
      O + '.vqp__close:focus-visible,' + O + '.vqp__btn:focus-visible,' + O + '.vqp__skip:focus-visible,' + O + '.vqp__copy:focus-visible,' + O + '.vqp__link:focus-visible,' + O + '.vqp__pick a:focus-visible{outline:2px solid #C8A27B;outline-offset:3px;}',
      '@media (max-width:860px){.vqp__card{grid-template-columns:240px minmax(0,1fr);}.vqp__frame{padding:28px 26px 24px;}.vqp__media{padding:22px;}}',
      /* Phone: a bottom sheet, full width, cover thumbnail beside the headline. */
      '@media (max-width:640px){' +
        '.vqp__overlay{align-items:flex-end;padding:0;}' +
        '.vqp__card{display:block;max-width:none;width:100%;max-height:92vh;border-radius:22px 22px 0 0;border-bottom:0;box-shadow:0 -20px 60px rgba(0,0,0,.3);transform:translateY(24px);}' +
        '.vqp__handle{display:block;}' +
        '.vqp__media{display:none;}' +
        '.vqp__frame{padding:14px 20px 28px;}' +
        O + '.vqp__close{top:10px;right:10px;}' +
        '.vqp__head{margin:0 0 10px;padding-right:28px;}' +
        '.vqp__thumb{display:block;}' +
        O + '.vqp__brand{margin:0 0 6px;}' +
        O + '.vqp__h{margin:0;font-size:24px;}' +
        O + '.vqp__sub{margin:0 0 14px;font-size:15px;}' +
        '.vqp__row{flex-direction:column;gap:10px;}' +
        O + '.vqp__input{height:52px;min-height:52px;}' +
        O + '.vqp__btn{width:100%;height:52px;min-height:52px;}' +
        O + '.vqp__code-value{font-size:22px;}' +
      '}',
      '@media (prefers-reduced-motion:reduce){.vqp__overlay,.vqp__card{transition:none;}.vqp__card{transform:none;}}'
    ].join('');
    var style = document.createElement('style');
    style.id = 'vqp-styles';
    style.textContent = css;
    document.head.appendChild(style);
  }

  function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }

  /* The guide cover (772x1000 PNG, 68 KB; the CDN's ?width=600 re-encode is larger). */
  var GUIDE_COVER = 'https://cdn.shopify.com/s/files/1/0660/1372/4750/files/veluna-mind-calm-sleep-guide-cover_ad0b64d6-7b31-449d-ac5c-085277c247ca.png';
  function defaultConcern() {
    return CONFIG.concerns.filter(function (c) { return c.id === 'mc'; })[0] || CONFIG.concerns[0];
  }
  /* "works until" date: the engine's value as given, or a readable date when it is
     an ISO timestamp (2026-10-08T23:59:00-04:00 -> Thursday, October 8). */
  function endsLabel(s) {
    s = String(s || '');
    if (!/^\d{4}-\d{2}-\d{2}/.test(s)) return s;
    var d = new Date(s);
    if (isNaN(d.getTime())) return s;
    try { return d.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' }); } catch (_) { return s; }
  }
  /* Thumbnail + eyebrow + headline. The thumbnail shows only on phones (the media
     panel shows the same cover on desktop), so each layout has exactly one picture. */
  function viewHead(eyebrow, h) {
    return '<div class="vqp__head"><img class="vqp__thumb" src="' + GUIDE_COVER + '" alt="The Veluna sleep guide" width="64" height="84" decoding="async" />' +
      '<div class="vqp__head-text"><p class="vqp__brand">' + eyebrow + '</p>' +
      '<h2 class="vqp__h" id="vqp-title">' + h + '</h2></div></div>';
  }

  function viewEmail() {
    var t = topic();
    return '' +
      viewHead('Reader offer', esc(t ? t.h : 'Get the sleep guide and 10% off')) +
      '<p class="vqp__sub">' + esc(t ? t.sub : 'Your 10% off code appears here and the sleep guide lands in your inbox.') + '</p>' +
      '<form class="vqp__form" data-form novalidate>' +
        '<div class="vqp__row">' +
        '<input class="vqp__input" type="email" name="email" placeholder="you@example.com" required autocomplete="email" aria-label="Email address" />' +
        '<button class="vqp__btn" type="submit" data-submit>Get my code</button>' +
        '</div>' +
        '<p class="vqp__error" data-error role="status" aria-live="polite"></p>' +
      '</form>' +
      '<p class="vqp__legal">One email a week at most. Unsubscribe any time.</p>' +
      '<p class="vqp__trust"><span>Third-party tested</span><span>30-night guarantee</span></p>' +
      '<button class="vqp__skip" data-skip type="button">No thanks</button>';
  }

  function viewSuccess(j, email) {
    var t = topic();
    var mine = j && j.signup_code;
    return '' +
      viewHead('Your code, ready now', 'Here is your 10% off') +
      '<div class="vqp__code"><span class="vqp__code-value" data-code>' + esc(mine || 'SLEEP10') + '</span>' +
      '<button class="vqp__copy" type="button" data-copy>Copy</button></div>' +
      '<p class="vqp__copied" data-copied role="status" aria-live="polite"></p>' +
      '<p class="vqp__sub vqp__code-note">' + (mine
        ? 'Your own code, works until ' + esc(endsLabel(j.signup_ends || '')) + '. Use it at checkout on your first set or the first delivery of a plan.'
        : 'Use it at checkout on your first set or the first delivery of a plan. Once per customer.') + '</p>' +
      '<div class="vqp__links">' +
      (t ? '<a class="vqp__link vqp__link--topic" href="' + esc(t.link) + '" data-topic-link>' + esc(t.label) + '</a>' : '') +
      '<a class="vqp__link" href="/pages/ritual-essentials" data-sets-link>See the sets</a></div>' +
      '<p class="vqp__legal">The sleep guide is on its way to ' + esc(email || '') + '.</p>' +
      '<p class="vqp__pick" data-pick><span>Pick your evening</span>' +
      '<a href="/pages/ritual-quiz">Mind</a><a href="/pages/ritual-quiz">Body</a><a href="/pages/ritual-quiz">Skin</a></p>';
  }

  function copyCode() {
    var code = popupEl && popupEl.querySelector('[data-code]');
    var note = popupEl && popupEl.querySelector('[data-copied]');
    var value = code ? (code.textContent || '').trim() : '';
    function ok() { if (note) note.textContent = 'Copied. Paste it into the discount box at checkout.'; }
    function fail() { if (note) note.textContent = 'Select the code to copy it.'; }
    try {
      if (value && navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(value).then(ok, fail); return; }
    } catch (_) {}
    fail();
  }

  function buildPopup() {
    if (popupEl) return popupEl;
    injectStyles();
    var overlay = document.createElement('div');
    overlay.className = 'vqp__overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-labelledby', 'vqp-title');
    overlay.setAttribute('data-capture-id', 'pdf-capture');
    overlay.innerHTML = '<div class="vqp__card">' +
      '<span class="vqp__handle" aria-hidden="true"></span>' +
      '<div class="vqp__media"><img src="' + GUIDE_COVER + '" alt="The Veluna sleep guide" width="300" height="389" decoding="async" /></div>' +
      '<button class="vqp__close" data-close aria-label="Close">' +
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6L6 18M6 6l12 12"/></svg>' +
      '</button><div class="vqp__frame" data-body></div></div>';
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closePopup('backdrop'); });
    overlay.querySelector('[data-close]').addEventListener('click', function () { closePopup('close-btn'); });
    overlay.querySelector('[data-body]').addEventListener('click', function (e) {
      if (e.target.closest('[data-skip]')) { closePopup('skip'); return; }
      if (e.target.closest('[data-copy]')) { copyCode(); }
    });
    overlay.querySelector('[data-body]').addEventListener('submit', function (e) {
      if (e.target.matches('[data-form]')) { e.preventDefault(); onEmailSubmit(e.target); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen) closePopup('esc'); });
    document.body.appendChild(overlay);
    popupEl = overlay;
    return popupEl;
  }

  function render(html) { popupEl.querySelector('[data-body]').innerHTML = html; }

  function familyFromCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || !cart.items) return null;
        for (var i = 0; i < cart.items.length; i++) {
          var h = String(cart.items[i].handle || '').toLowerCase();
          for (var j = 0; j < CONFIG.concerns.length; j++) {
            if (h.indexOf(CONFIG.concerns[j].match) !== -1) return CONFIG.concerns[j];
          }
        }
        return null;
      }).catch(function () { return null; });
  }

  function open(reason, preset) {
    buildPopup();
    /* 2026-10-01: straight to the email step. The concern behind the POST is the
       article's mapped one when there is one, else Mind Calm. */
    selected = preset || defaultConcern();
    render(viewEmail());
    try { window.VelunaCaptureGuard && window.VelunaCaptureGuard.notifyOpen('pdf-capture'); } catch (_) {}
    requestAnimationFrame(function () { popupEl.classList.add('is-open'); });
    document.body.style.overflow = 'hidden';
    isOpen = true;
    recordShown();
    try {
      var G = window.VelunaCaptureGuard;
      releaseFocus = G && G.holdFocus ? G.holdFocus(popupEl, { focus: false }) : null;
    } catch (_) { releaseFocus = null; }
    if (surface() === 'cart') ssSet(CONFIG.storage.cartShown, '1');
    setTimeout(function () {
      var f = popupEl && popupEl.querySelector('input[type="email"]');
      if (f) { try { f.focus({ preventScroll: true }); } catch (_) {} }
    }, 60);
    try { if (window.dataLayer) window.dataLayer.push({ event: 'veluna_popup_shown', trigger: reason, surface: surface() }); } catch (_) {}
    gaPopup('veluna_popup_shown', { engine: 'guide_popup', surface: surface(), trigger: triggerName(reason) });
  }

  function showPopup(reason) {
    if (!shouldShow()) return;
    open(reason, surface() === 'article' ? articleConcern() : null);
  }

  function closePopup(reason) {
    if (!popupEl) return;
    popupEl.classList.remove('is-open');
    document.body.style.overflow = '';
    isOpen = false;
    try { window.VelunaCaptureGuard && window.VelunaCaptureGuard.notifyClosed('pdf-capture'); } catch (_) {}
    lsSet(CONFIG.storage.lastShown, String(Date.now()));
    if (!isCaptured()) {
      lsSet(CONFIG.storage.dismissedUntil, String(Date.now() + CONFIG.timing.suppressMs));
      ssSet(CONFIG.storage.sessionDismissed, '1');
      try { window.VelunaCaptureGuard && window.VelunaCaptureGuard.notifyDismissed && window.VelunaCaptureGuard.notifyDismissed('pdf-capture'); } catch (_) {}
      gaPopup('veluna_popup_dismissed', { engine: 'guide_popup', surface: surface() });
    }
    if (dwellTimer) { clearTimeout(dwellTimer); dwellTimer = null; }
    if (releaseFocus) { try { releaseFocus(); } catch (_) {} releaseFocus = null; }
    var el = popupEl;
    setTimeout(function () { if (el) el.remove(); if (popupEl === el) popupEl = null; }, 250);
  }

  function markCaptured(email) {
    lsSet(CONFIG.storage.captured, 'true');
    lsSet('veluna_pdf_captured', email + '|' + Date.now());
    lsSet('veluna_quiz_email', email);
    lsSet('veluna_quiz_email_captured', 'true');
  }

  function onEmailSubmit(form) {
    var input = form.querySelector('input[type="email"]');
    var errEl = form.querySelector('[data-error]');
    var btn = form.querySelector('[data-submit]');
    var email = (input.value || '').trim();
    errEl.textContent = '';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { errEl.textContent = 'Please enter a full email address.'; return; }
    btn.disabled = true; btn.textContent = 'Sending…';
    submitToBackend(email).then(function (res) {
      if (!res || !res.ok) throw new Error('network');
      return res.json().catch(function () { return {}; });
    }).then(function (j) {
      markCaptured(email);
      fireLead({ source: sourceName(), concern: selected.id, surface: surface() });
      render(viewSuccess(j, email));
      setTimeout(function () { var b = popupEl && popupEl.querySelector('[data-copy]'); if (b) { try { b.focus({ preventScroll: true }); } catch (_) {} } }, 40);
      try { if (window.dataLayer) window.dataLayer.push({ event: 'veluna_lead_captured', sleep_concern: selected.id, ritual_type: selected.ritual, surface: surface() }); } catch (_) {}
    }).catch(function () {
      errEl.textContent = 'That did not go through. Please try again.';
      btn.disabled = false; btn.textContent = 'Get my code';
    });
  }

  function submitToBackend(email) {
    var c = selected;
    return fetch(CONFIG.backend.url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: email,
        topic: 'popup_subscribe',
        want_code: true,
        /* Top-level concern: this is what routes the welcome email to the
           right guide. Without it the engine falls back to Mind Calm. */
        concern: c.id,
        first_name: '',
        source: sourceName(),
        email_sequence: CONFIG.backend.sequence,
        popup_variant: CONFIG.backend.popupVariant,
        tags: ['veluna_quiz_popup', 'concern_' + c.id, CONFIG.backend.sequence, 'surface_' + surface()],
        fields: { sleep_concern: c.id, ritual_type: c.ritual, email_sequence: CONFIG.backend.sequence,
                  ritual_guide_url: c.guide, popup_variant: CONFIG.backend.popupVariant },
        metadata: { page: window.location.pathname, referrer: document.referrer || '',
                    user_agent: (navigator && navigator.userAgent) || '' }
      })
    }).catch(function () { return null; });
  }

  var FINE_POINTER = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);
  var COARSE = !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
  function scrolledPast(fraction) {
    var h = document.documentElement;
    return (h.scrollTop + window.innerHeight) / (h.scrollHeight || 1) >= fraction;
  }
  /* 2026-10-01 phone triggers (coarse pointer; articles and browse pages). Phones have no
     exit intent, so two reading signals stand in for it:
       scroll-up: more than 250 px back up (cumulative) after reaching half the page;
       idle:      10 s with no scroll or touch after reaching 40% of the page.
     Both go through shouldShow() like every other trigger, so the guard, the cooldown,
     the dismissal keys and "already captured" all still apply. Registered before the
     surface's own scroll rule so a scroll-up is reported as such when both qualify. */
  function installPhoneTriggers() {
    var reachedHalf = false, reached40 = false, upAcc = 0, idleTimer = null;
    var lastY = window.scrollY || document.documentElement.scrollTop || 0;
    function armIdle() {
      if (idleTimer) clearTimeout(idleTimer);
      idleTimer = setTimeout(function () { idleTimer = null; if (reached40 && shouldShow()) showPopup('idle'); }, 10000);
    }
    window.addEventListener('scroll', function () {
      var y = window.scrollY || document.documentElement.scrollTop || 0;
      if (scrolledPast(0.5)) reachedHalf = true;
      if (scrolledPast(0.4)) reached40 = true;
      if (y < lastY) upAcc += lastY - y; else upAcc = 0;
      lastY = y;
      if (reachedHalf && upAcc > 250) { upAcc = 0; if (shouldShow()) showPopup('scroll-up'); }
      armIdle();
    }, { passive: true });
    document.addEventListener('touchstart', armIdle, { passive: true });
    document.addEventListener('touchmove', armIdle, { passive: true });
    armIdle();
  }
  function installTriggers() {
    if (triggersInstalled) return;
    triggersInstalled = true;
    var s = surface();
    var loadedAt = Date.now();
    if (COARSE && (s === 'article' || s === 'browse')) installPhoneTriggers();
    if (s === 'browse') {
      /* Browse pages: exit intent on desktop (below). Touch devices (2026-09-30):
         40% scrolled after at least 15 s on the page. */
      if (!FINE_POINTER) {
        var tryBrowse = function (reason) {
          if (Date.now() - loadedAt < 15000 || !scrolledPast(0.4)) return;
          if (shouldShow()) showPopup(reason);
        };
        window.addEventListener('scroll', function () { tryBrowse('scroll'); }, { passive: true });
        setTimeout(function () { tryBrowse('scroll-dwell'); }, 15050);
      }
    } else if (s === 'article') {
      /* Articles: gentle only. Desktop: 60% read, or exit intent below.
         Touch: 60% read AND at least 30 s on the page. No timer on its own. */
      var tryArticle = function (reason) {
        if (!scrolledPast(CONFIG.timing.articleScroll)) return;
        if (!FINE_POINTER && Date.now() - loadedAt < CONFIG.timing.articleMobileMinMs) return;
        if (shouldShow()) showPopup(reason);
      };
      window.addEventListener('scroll', function () { tryArticle('scroll'); }, { passive: true });
      if (!FINE_POINTER) setTimeout(function () { tryArticle('scroll-dwell'); }, CONFIG.timing.articleMobileMinMs + 50);
    } else {
      window.addEventListener('scroll', function () {
        if (!shouldShow()) return;
        if (scrolledPast(CONFIG.timing.scrollThreshold)) showPopup('scroll');
      }, { passive: true });
      if (dwellTimer) clearTimeout(dwellTimer);
      /* 2026-09-30: re-check every 5 s (up to 12 times) so a guard block at the 20 s mark is not final. */
      var dwellTries = 0;
      var dwellCheck = function () {
        if (shouldShow()) { showPopup('dwell'); return; }
        if (++dwellTries < 12) dwellTimer = setTimeout(dwellCheck, 5000);
      };
      dwellTimer = setTimeout(dwellCheck, CONFIG.timing.dwellMs);
    }
    /* Desktop only: the pointer leaves through the top. A quick flick reports
       its last sampled position, often tens of pixels down, so allow 80 px.
       Nothing re-arms after a close (2026-09-23). */
    if (FINE_POINTER) {
      document.addEventListener('mouseout', function (e) {
        if (e.relatedTarget || e.clientY >= 80) return;
        EXITING = true;
        try { if (shouldShow()) showPopup('exit-intent'); } finally { EXITING = false; }
      });
    }
  }

  function init() {
    if (!surface()) return;
    if (!PREVIEW && (isCaptured() || isPermanentlyDismissed())) return;
    installTriggers();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.__velunaPopupTest = function () {
    try { localStorage.removeItem(CONFIG.storage.captured); localStorage.removeItem(CONFIG.storage.dismissed);
          localStorage.removeItem(CONFIG.storage.lastShown); sessionStorage.removeItem(CONFIG.storage.cartShown);
          localStorage.removeItem(CONFIG.storage.dismissedUntil); sessionStorage.removeItem(CONFIG.storage.sessionDismissed); } catch (_) {}
    showPopup('manual-test');
  };
})();
/**
 * Veluna PDF Capture - unified email capture popup engine (Phase G).
 *
 * Replaces the fragmented set of:
 *   - veluna-homepage-popup.js
 *   - veluna-quiz-abandon.js
 *   - veluna-platform-aware-popup.js
 *   - veluna-popup-optimization.js
 *   - veluna-popup-templates.js
 *   - veluna-advanced-email.js
 *   - veluna-email-v3.js
 *   - veluna-email.js
 *
 * Architecture:
 *   1. Triggers are surface-specific (homepage / pdp / quiz / cart) and gated
 *      by the Unified Popup Manager's 30-min session lockout.
 *   2. Each trigger dispatches a `luna-popup-decision` event with a
 *      surface-aware payload. The unified manager renders.
 *   3. Templates are registered into `window.VelunaPopupTemplates` and use the
 *      free PDF guide as the universal hook (no mystery discount, IM8 tone).
 *   4. Submission posts to the Veluna subscribe API (API Gateway /Prod/subscribe)
 *      and emits a `veluna-email-captured` event for analytics.
 *
 * Frequency / dedupe rules:
 *   - Global: 30 minutes per session via UnifiedPopupManager.
 *   - Per surface: 1 per 7 days for homepage; 1 per session for pdp / cart;
 *     1 per session + 1 per 7 days global for quiz.
 *
 * Safe-to-load fallback: if UnifiedPopupManager is missing, the engine
 * silently no-ops so it never blocks the page.
 */
(function () {
  'use strict';

  if (window.__VELUNA_PDF_CAPTURE_LOADED__) return;
  window.__VELUNA_PDF_CAPTURE_LOADED__ = true;

  /* FIX 2026-09-22: dispatch() read `isOpen` and `inCooldown()`, which only
     exist inside block 1's closure, so every dispatch threw
     "ReferenceError: isOpen is not defined" and no popup ever opened. These are
     block 2's own. The cooldown reads the same key block 1 writes, which is
     what the original comment in dispatch() intended. */
  var isOpen = false;
  function inCooldown() {
    try {
      var last = parseInt(localStorage.getItem('veluna_popup_last_shown') || '0', 10);
      return !!last && (Date.now() - last) < 60000;
    } catch (e) { return false; }
  }

  // ---------------------------------------------------------------------------
  // Storage keys + helpers
  // ---------------------------------------------------------------------------
  const STORE = {
    captured: 'veluna_pdf_captured',          // localStorage: email captured
    lastShown: 'veluna_pdf_last_shown',       // localStorage: per-surface ts
    sessionShown: 'veluna_pdf_session_shown', // sessionStorage: per-surface
  };
  const DAY = 24 * 60 * 60 * 1000;
  const FREQ = {
    homepage: { perDays: 7,  perSession: false },
    pdp:      { perDays: 0,  perSession: true  },
    quiz:     { perDays: 7,  perSession: true  },
    cart:     { perDays: 0,  perSession: true  },
  };

  function isCaptured() {
    try { return !!localStorage.getItem(STORE.captured); } catch (e) { return false; }
  }
  function markCaptured(email) {
    try { localStorage.setItem(STORE.captured, email + '|' + Date.now()); } catch (e) {}
  }
  function lastShown(surface) {
    try {
      const map = JSON.parse(localStorage.getItem(STORE.lastShown) || '{}');
      return Number(map[surface] || 0);
    } catch (e) { return 0; }
  }
  function recordShown(surface) {
    try {
      const map = JSON.parse(localStorage.getItem(STORE.lastShown) || '{}');
      map[surface] = Date.now();
      localStorage.setItem(STORE.lastShown, JSON.stringify(map));
      const sess = JSON.parse(sessionStorage.getItem(STORE.sessionShown) || '{}');
      sess[surface] = 1;
      sessionStorage.setItem(STORE.sessionShown, JSON.stringify(sess));
    } catch (e) {}
  }
  function sessionShown(surface) {
    try {
      const sess = JSON.parse(sessionStorage.getItem(STORE.sessionShown) || '{}');
      return !!sess[surface];
    } catch (e) { return false; }
  }
  function eligible(surface) {
    if (isCaptured()) return false;
    const rules = FREQ[surface] || FREQ.homepage;
    if (rules.perSession && sessionShown(surface)) return false;
    if (rules.perDays > 0) {
      const since = Date.now() - lastShown(surface);
      if (since < rules.perDays * DAY) return false;
    }
    // Global manager 30-min lockout
    if (window.unifiedPopupManager && window.unifiedPopupManager.hasShownThisSession &&
        window.unifiedPopupManager.hasShownThisSession()) return false;
    return true;
  }

  // ---------------------------------------------------------------------------
  // Surface detection
  // ---------------------------------------------------------------------------
  function detectSurface() {
    const t = (window.VelunaThemeSettings && window.VelunaThemeSettings.template) || '';
    const path = location.pathname;
    if (path === '/' || t === 'index') return 'homepage';
    if (path.indexOf('/products/') === 0 || t.indexOf('product') === 0) return 'pdp';
    if (path.indexOf('/pages/quiz') === 0 || /quiz|ritual-finder|sleep-quiz/.test(path)) return 'quiz';
    if (path.indexOf('/cart') === 0) return 'cart';
    return null;
  }

  // ---------------------------------------------------------------------------
  // Guide title resolver (drives PDP family-specific copy)
  // ---------------------------------------------------------------------------
  function resolveGuideTitle() {
    // Prefer explicit template hint set by my-ritual / PDP sections
    const hint = (window.VelunaThemeSettings && window.VelunaThemeSettings.popupVariant) || '';
    const map = {
      mind_calm_reset_guide:        'The Mind Calm Reset Guide',
      muscle_recovery_protocol:      'The Muscle Recovery Protocol',
      circadian_rhythm_handbook:     'The Circadian Rhythm Handbook',
      hormone_balance_blueprint:     'The Hormone Balance Blueprint',
      sleep_foundations_guide:       'The Sleep Foundations Guide',
    };
    if (hint && map[hint]) return map[hint];
    // PDP fallback by product handle
    if (location.pathname.indexOf('/products/') === 0) {
      const h = location.pathname.split('/').pop() || '';
      if (/mind-calm|theanine|magnesium-glycinate/.test(h)) return map.mind_calm_reset_guide;
      if (/muscle|recovery|threonate|magnesium-malate/.test(h)) return map.muscle_recovery_protocol;
      if (/circadian|reset|jetlag|melatonin|light/.test(h)) return map.circadian_rhythm_handbook;
      if (/hormone|cycle|woman|estrogen|progesterone/.test(h)) return map.hormone_balance_blueprint;
    }
    return map.sleep_foundations_guide;
  }

  // ---------------------------------------------------------------------------
  // Decision dispatcher
  // ---------------------------------------------------------------------------
  function dispatch(surface, reason) {
    if (!eligible(surface)) return;
    /* This path renders through UnifiedPopupManager and previously bypassed the
       capture guard entirely, so it could open a second intrusive overlay and
       could steal the lane from a page-specific engine. */
    var queued = (window.__vlnPageSpecific || []).filter(function (id) {
      return id && id !== 'pdf-capture';
    });
    if (queued.length) return;   // a dedicated capture owns this page type
    /* This engine has two rendering paths: its own .vqp__overlay and this
       delegated one. Only the first honoured the dismissal cooldown, so a
       visitor who closed the popup saw the delegated copy reappear seconds
       later. Both paths now share one cooldown. */
    if (isOpen || inCooldown()) return;
    if (window.VelunaCaptureGuard) {
      if (window.VelunaCaptureGuard.hasPageSpecific('pdf-capture')) return;
      if (!window.VelunaCaptureGuard.mayShow('pdf-capture')) return;
    }
    const guide = resolveGuideTitle();
    const decision = {
      // `popupType` is what UnifiedPopupManager.getTemplate() reads; keep
      // `type` for backwards-compat with anything else listening.
      popupType: 'pdf_capture',
      type: 'pdf_capture',
      /* The renderer must claim the guard as THIS engine, not as itself. */
      captureId: 'pdf-capture',
      surface: surface,
      reason: reason,
      payload: {
        guideTitle: guide,
        cta: 'Email me the guide',
        privacy: 'No spam. Unsubscribe anytime.',
      },
    };
    recordShown(surface);
    let displayed = false;
    if (window.unifiedPopupManager && typeof window.unifiedPopupManager.showPopup === 'function') {
      displayed = window.unifiedPopupManager.showPopup(decision) === true;
    } else {
      window.dispatchEvent(new CustomEvent('luna-popup-decision', { detail: decision }));
    }
    if (!displayed) {
      // Manager refused (e.g. already shown). Don't keep the surface locked.
      try {
        const map = JSON.parse(localStorage.getItem(STORE.lastShown) || '{}');
        delete map[surface];
        localStorage.setItem(STORE.lastShown, JSON.stringify(map));
      } catch (e) {}
    }
    if (window.VELUNA_ANALYTICS_ENDPOINT) {
      try {
        fetch(window.VELUNA_ANALYTICS_ENDPOINT, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            event: 'pdf_capture_shown',
            surface: surface,
            reason: reason,
            guide: guide,
            ts: Date.now(),
          }),
          keepalive: true,
        }).catch(function () {});
      } catch (e) {}
    }
  }

  // ---------------------------------------------------------------------------
  // Trigger primitives
  // ---------------------------------------------------------------------------
  function onDwell(seconds, fn) {
    let fired = false;
    setTimeout(function () { if (!fired) { fired = true; fn(); } }, seconds * 1000);
  }
  function onScroll(percent, fn) {
    let fired = false;
    function check() {
      if (fired) return;
      const h = document.documentElement;
      const scrolled = (window.scrollY + window.innerHeight) / (h.scrollHeight || 1);
      if (scrolled >= percent) { fired = true; fn(); window.removeEventListener('scroll', check); }
    }
    window.addEventListener('scroll', check, { passive: true });
  }
  function onExitIntent(fn) {
    let fired = false;
    document.addEventListener('mouseout', function (e) {
      if (fired) return;
      if (e.clientY <= 5 && (!e.relatedTarget && !e.toElement)) { fired = true; fn(); }
    });
  }
  function onIdle(seconds, fn) {
    let timer; let fired = false;
    function reset() {
      if (fired) return;
      clearTimeout(timer);
      timer = setTimeout(function () { fired = true; fn(); }, seconds * 1000);
    }
    ['mousemove', 'keydown', 'scroll', 'touchstart', 'click'].forEach(function (ev) {
      document.addEventListener(ev, reset, { passive: true });
    });
    reset();
  }

  // ---------------------------------------------------------------------------
  // Surface installers
  // ---------------------------------------------------------------------------
  function installHomepage() {
    if (!eligible('homepage')) return;
    onDwell(30, function () { dispatch('homepage', 'dwell_30s'); });
    onScroll(0.6, function () { dispatch('homepage', 'scroll_60'); });
    onExitIntent(function () { dispatch('homepage', 'exit_intent'); });
  }
  function installPdp() {
    if (!eligible('pdp')) return;
    onDwell(45, function () { dispatch('pdp', 'dwell_45s'); });
    onExitIntent(function () { dispatch('pdp', 'exit_intent'); });
  }
  function installQuiz() {
    if (!eligible('quiz')) return;
    onIdle(90, function () { dispatch('quiz', 'idle_90s'); });
    onExitIntent(function () { dispatch('quiz', 'exit_intent'); });
  }
  function installCart() {
    if (!eligible('cart')) return;
    onExitIntent(function () { dispatch('cart', 'exit_intent'); });
  }

  // ---------------------------------------------------------------------------
  // Template (consumed by UnifiedPopupManager).
  //
  // Manager contract (see veluna-unified-popup-manager.js):
  //   - getTemplate(decision.popupType) must return an object
  //   - renderPopup() calls `template.render(decision)` and expects an HTML
  //     string back
  //   - attachListeners() is called separately by the manager to wire close /
  //     submit handlers; we use a MutationObserver here as a lightweight
  //     binder so the engine remains decoupled from the manager's internals.
  // ---------------------------------------------------------------------------
  function buildHtml(decision) {
    const p = (decision && decision.payload) || {};
    const guide = p.guideTitle || 'The Sleep Foundations Guide';
    // Close elements carry BOTH `data-popup-close` (UnifiedPopupManager hook)
    // and `data-vpc-close` (legacy / standalone fallback). Form has no inline
    // submit handler - the manager attaches one in `attachListeners()` and
    // posts to the subscribe API (/Prod/subscribe) with `popup_type` + `luna_decision`.
    return ''+
      '<div class="veluna-pdf-capture" role="dialog" aria-modal="true" aria-labelledby="vpc-title">'+
      '  <div class="vpc__overlay" data-popup-close data-vpc-close></div>'+
      '  <div class="vpc__card">'+
      '    <button type="button" class="vpc__close" data-popup-close data-vpc-close aria-label="Close">×</button>'+
      '    <div class="vpc__badge"><span class="vpc__badge-lbl">Free guide</span></div>'+
      '    <h2 id="vpc-title" class="vpc__title">'+guide+'</h2>'+
      '    <p class="vpc__sub">The evening step by step, what is in each product, and a 30-night tracker. We email it to you. Free, no purchase needed.</p>'+
      '    <form class="vpc__form" data-vpc-form data-veluna-email data-source="pdf_capture_'+(decision.surface||'unknown')+'">'+
      '      <label class="vpc__field"><input type="email" name="email" placeholder="your.email@example.com" required autocomplete="email" /></label>'+
      '      <button type="submit" class="vpc__submit">Email me the guide</button>'+
      '    </form>'+
      '    <p class="vpc__privacy">No spam. Unsubscribe anytime.</p>'+
      '  </div>'+
      '</div>';
  }

  window.VelunaPopupTemplates = window.VelunaPopupTemplates || {};
  window.VelunaPopupTemplates.pdf_capture = {
    type: 'pdf_capture',
    render: function (decision) {
      window.__VPC_LAST_DECISION__ = decision;
      return buildHtml(decision);
    },
  };

  // ---------------------------------------------------------------------------
  // Boot
  // ---------------------------------------------------------------------------
  // Stylesheet injection - self-contained, no external CSS dependency.
  // The unified popup manager appends `.unified-popup` to <body> and toggles
  // `.unified-popup--visible`; we own those classes here plus the .vpc__*
  // template internals so the popup is always visible without theme CSS.
  // ---------------------------------------------------------------------------
  function injectStyles() {
    if (document.getElementById('vpc-styles')) return;
    const css =
      '.unified-popup{position:fixed;inset:0;z-index:99999;display:flex;align-items:center;justify-content:center;'+
      'opacity:0;visibility:hidden;transition:opacity .25s ease;pointer-events:none;}'+
      '.unified-popup--visible{opacity:1;visibility:visible;pointer-events:auto;}'+
      '.vpc__overlay{position:absolute;inset:0;background:rgba(15,17,22,.72);backdrop-filter:blur(4px);}'+
      '.vpc__card{position:relative;background:#fff;color:#1F1A16;max-width:440px;width:calc(100% - 32px);'+
      'border-radius:18px;padding:32px 28px 28px;box-shadow:0 24px 64px rgba(0,0,0,.32);'+
      'font-family:Hanken Grotesk, Helvetica Neue, Arial, sans-serif;'+
      'animation:vpc-in .35s cubic-bezier(.2,.7,.3,1) both;}'+
      '@keyframes vpc-in{from{transform:translateY(12px) scale(.98);opacity:0}to{transform:none;opacity:1}}'+
      '.vpc__close{position:absolute;top:12px;right:14px;background:transparent;border:0;font-size:26px;'+
      'line-height:1;color:#8A8378;cursor:pointer;padding:6px 10px;border-radius:8px;}'+
      '.vpc__close:hover{background:#E8DDD0;color:#1F1A16;}'+
      '.vpc__badge{display:inline-flex;align-items:baseline;gap:6px;background:#fef3c7;color:#92400e;'+
      'padding:6px 12px;border-radius:999px;font-size:12px;font-weight:600;margin-bottom:14px;}'+
      '.vpc__badge-num{font-size:14px;font-weight:700;}'+
      '.vpc__title{font-size:24px;line-height:1.2;margin:0 0 10px;font-weight:600;letter-spacing:-.01em;}'+
      '.vpc__sub{font-size:14px;line-height:1.55;color:#6B665E;margin:0 0 20px;}'+
      '.vpc__form{display:flex;flex-direction:column;gap:10px;}'+
      '.vpc__field input{width:100%;padding:12px 14px;border:1px solid #D8D0C2;border-radius:10px;'+
      'font-size:15px;color:#1F1A16;background:#F5F2EB;outline:none;transition:border-color .15s,background .15s;}'+
      '.vpc__field input:focus{border-color:#1F1A16;background:#fff;}'+
      '.vpc__submit{padding:13px 16px;background:#1F1A16;color:#fff;border:0;border-radius:10px;'+
      'font-size:15px;font-weight:600;cursor:pointer;transition:transform .1s,background .15s;}'+
      '.vpc__submit:hover{background:#3A2618;}'+
      '.vpc__submit:active{transform:translateY(1px);}'+
      '.vpc__privacy{margin:14px 0 0;font-size:11px;color:#B9B0A2;text-align:center;letter-spacing:.02em;}'+
      '@media(max-width:480px){.vpc__card{padding:26px 22px 22px;border-radius:14px;}.vpc__title{font-size:20px;}}';
    const tag = document.createElement('style');
    tag.id = 'vpc-styles';
    tag.textContent = css;
    document.head.appendChild(tag);
  }

  // ---------------------------------------------------------------------------
  function boot() {
    injectStyles();
    const surface = detectSurface();
    if (!surface) return;
    /* DISARMED 2026-09-22. Homepage and cart are handled by the guide popup
       above (block 1), which always sends a concern code; this engine sends
       none, so its signups got the Mind Calm guide whatever they were
       promised. The quiz has its own page-specific exit popup. The engine and
       its template stay so re-enabling is one line, but it must send a concern
       before it is. */
    return;
    if (surface === 'homepage') installHomepage();
    // PDP intentionally skipped - veluna-pdp-mystery.js owns this surface
    // (mystery scratch popup with discount + ATC). Running both engines causes
    // popup collision via UnifiedPopupManager's 30-min lockout.
    else if (surface === 'pdp') return;
    else if (surface === 'quiz') installQuiz();
    else if (surface === 'cart') installCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
